import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-form-new-schedule',
  templateUrl: './turns-form-new-schedule.component.html',
  styleUrls: ['./turns-form-new-schedule.component.scss']
})
export class TurnsFormNewScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
